import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, ColumnLayout, Form, FormSection} from '@amzn/awsui-components-react/';
import {reduxForm} from 'redux-form';

import PolarisTextAreaField from 'views/components/Form/PolarisTextAreaField';

import fetchPlan from 'actions/plan';
import dispatchSubmitForm, {redirectHome} from 'constants/functions';
import {COSELLING} from 'constants/forms';
import {FeedbackHeader} from "views/components/FeedbackHeader";

const FORM_NAME = COSELLING;

//TODO: Leaving empty because of all TextArea fields

class CoSelling extends Component {
  componentDidMount() {
    this.props.fetchPlan(this.props.match.params.planId);
  }

  render() {
    const {handleSubmit, dispatch, planId, formName, history} = this.props;
    return (
      <div>
        <div>
          {FeedbackHeader(history)}
        </div>

        <Form
          onSubmit={handleSubmit}
          actions={
            <div>
              <Button text="Cancel" variant="link" onClick={() => redirectHome(history, planId)}/>
              <Button
                onClick={handleSubmit(values => {
                  dispatchSubmitForm(
                    {
                      values,
                      form: FORM_NAME,
                      completed: false,
                      planId,
                      formName
                    },
                    dispatch
                  );
                })}
                text="Save as Draft"
                variant="primary"
              />
              <Button
                onClick={handleSubmit(values => {
                  dispatchSubmitForm(
                    {
                      values,
                      form: FORM_NAME,
                      completed: true,
                      planId,
                      formName
                    },
                    dispatch
                  );
                  this.props.history.push('/plans/' + planId);
                })}
                text="Submit"
                variant="primary"
              />
            </div>
          }
        >
          <FormSection header="Co-Selling">
            <ColumnLayout>
              <div data-awsui-column-layout-root="true">
                <PolarisTextAreaField
                  label="Are sellers comped for AWS? Are their incentives neutral, AWS positive or AWS negative?"
                  placeholder="Enter here..."
                  name="sellerIncentive"
                />

                <PolarisTextAreaField
                  label="What is their relationship with Microsoft Azure and Legacy businesses?"
                  placeholder="Enter here..."
                  name="competitiveRelationship"
                />
                <PolarisTextAreaField
                  label="Are there other public cloud businesses which your sellers are focused on?"
                  placeholder="Enter here..."
                  name="publicCloudRelationship"
                />
                <PolarisTextAreaField
                  label="Is partner engaged with co-selling efforts with AWS today? In what form?"
                  placeholder="Enter here..."
                  name="engagedCoSellingEffots"
                />
                <PolarisTextAreaField
                  label="Does partner have new solution under development in which they would like co-selling support?"
                  placeholder="Enter here..."
                  name="newSolutionDevelopment"
                />
                <PolarisTextAreaField
                  label="How does the partner solution drive AWS sales goals (help meet quota or SPIF)? "
                  placeholder="Enter here..."
                  name="solutionDriveAWSSalesGoals"
                />
                <PolarisTextAreaField
                  label="Enter the most successful use-cases from a GTM perspective."
                  placeholder="Enter here..."
                  name="successfulUseCases"
                />
              </div>
            </ColumnLayout>
          </FormSection>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    planId: state.plan.plan.id,
    formName: FORM_NAME,
    initialValues: {
      ...state.plan.plan.forms[FORM_NAME]
    }
  };
};

const mapDispatchToProps = dispatch => {
  //TODO: Remove/change this
  return {
    fetchPlan: planId => dispatch(fetchPlan(planId)),
    dispatch
  };
};

const formDecoratedComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true
})(CoSelling);
const connectDecoratedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(formDecoratedComponent);

export default withRouter(connectDecoratedComponent);
